import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
let InformationBoxSummaryService = class InformationBoxSummaryService {
    constructor() {
        this.updateOT = new BehaviorSubject({});
    }
    setdataOR(value) {
        this.ordenSeleccionada = value;
        this.updateOT.next(value);
    }
    observerUpdateOT() {
        return this.updateOT.asObservable();
    }
    set ocultarInfo(value) {
        this.deshabiliarInfo = value;
    }
    get ocultarInfo() {
        return this.deshabiliarInfo;
    }
};
InformationBoxSummaryService = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [])
], InformationBoxSummaryService);
export { InformationBoxSummaryService };
